import { NavLink } from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';
import "./Navbar.css"
import { useState } from "react";

export default function NavbarLink({ path, title, closeNavbar, external, newTab, subLinks }) {
 const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
 // If link is using a HashLink rather than a normal link.
 const LinkComponent = path.includes("#") ? NavHashLink : NavLink;

 if (external) {
  return (
   <a href={path} target={newTab || newTab == null ? "_blank" : "_self"} rel="noreferrer" className="custom-nav-link text-decoration-none mx-3">
    {title}
   </a>
  );
 }

 const handleClick = (event) => {
  if (path === window.location.pathname) {
   event.preventDefault();
   window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  if (typeof closeNavbar === 'function') {
   closeNavbar();
  }
 };

 if (subLinks && subLinks.length > 0) {
  return (
   <div className={`nav-item mt-2 mt-lg-0 dropdown-parent ${ isMobileMenuOpen ? "is-open" : "" }`}>
    <a
     className="custom-nav-link text-decoration-none mx-3"
     aria-haspopup="true"
     aria-expanded={isMobileMenuOpen}
     onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
    >
     {title}
    
     <span className="chev ai-chevron-down ml-2" aria-hidden="true"></span>
     
    </a>

    <div className="dropdown-menu" role="menu" aria-label={`${ title } submenu`}>
     {subLinks.map((subLink, index) => (
      <a
       key={index}
       href={subLink.path}
       target="_self"
       className="dropdown-item"
       onClick={() => setIsMobileMenuOpen(false)}
      >
       {subLink.title}
      </a>
     ))}
    </div>
   </div>
  );
 }

 // Custom wrapper component to handle click event
 const CustomLink = ({ to, exact, activeClassName, className, children }) => {
  const handleLinkClick = (event) => {
   handleClick(event);
  };

  return (
   <LinkComponent
    to={to}
    exact={exact}
    activeClassName={activeClassName}
    className={className}
    onClick={handleLinkClick}
   >
    {children}
   </LinkComponent>
  );
 };

 return (
  <CustomLink
   to={path}
   exact
   activeClassName={!path.includes("#") ? "active" : ""}
   className="custom-nav-link text-decoration-none mx-3"
  >
   <span>{title}</span>
  </CustomLink>
 );
}
